import React, { Component } from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import ActionData from '../../types/ActionData'
import Organization from '../../types/Organization'
import Provider from '../../types/Provider'
import User from '../../types/User'
import { authUser, getUserByEmail, setProviderList, setSelectedProvider, setSelectedOrganization, setUser, showOrganizationModal } from '../../redux/actions/authentication'
import { getProviders } from '../../redux/actions/userAccount'
import { getCarePlanToSign } from '../../redux/actions/carePlan'
import { getDetailToUpdate } from '../../redux/actions/providerDetail'

interface AuthenticatedProps {
  authentication: { isAuth: boolean; user: any; loginUser: any; authMember: any};
  providerData: ActionData;
  height: number;
  selectedOrganization: Organization;
  width:  number;
  authUser: (isAuth: boolean) => void;
  getCarePlanToSign: (organizationId: number, eid: string, token: string) => void;
  getDetailToUpdate: (id: number, eid: string, token: string) => void;
  getUserByEmail: (data: {email: string; generateToken: boolean} ) => void;
  getProviders: (organization_id: number, token: string) => void;
  setProviderList: (providerList: Array<Provider>) => void;
  setSelectedOrganization: (organization: Organization) => void;
  setSelectedProvider: (provider: Provider) => void;
  setUser: (data: User) => void;
  showOrganizationModal: (organizationModal: boolean) => void;
}

interface AuthenticatedState {
  isAuthenticated: boolean | undefined;
}

const isAuthenticated = (ComposedComponent: any) => {
  class Authenticated extends Component<
  AuthenticatedProps & RouteComponentProps<{}>,
  AuthenticatedState
  > {

    componentDidMount(){
      const { authentication, history, authUser, getUserByEmail, setUser, setSelectedOrganization, setSelectedProvider, showOrganizationModal } = this.props
	    if (authentication.isAuth !== true){
        if(authentication.authMember.data.length>0){
          authUser(true)
          setUser(authentication.authMember.data[0])
        
          if(authentication.authMember.data[0].organization_data.length>0){
            if(authentication.authMember.data[0].organization_data.length===1) {
              setSelectedOrganization(authentication.authMember.data[0].organization_data[0])
            }
            else
              showOrganizationModal(true)
          }

          if(authentication.authMember.data[0].provider_data.length!==0) {
            setSelectedProvider(authentication.authMember.data[0].provider_data[0])
          }
        }
        else{
          if(localStorage.getItem('p_sid')!==null) {
            let generateToken = false
            let email = JSON.parse(localStorage.getItem('p_sid')|| '{}')

            if(localStorage.getItem('token') === null || localStorage.getItem('token')==='undefined'){
              generateToken = true
              localStorage.removeItem('token')
            }
          
            email.generateToken = generateToken 
            getUserByEmail(email)
          } 
          else{
            if(authentication.loginUser.data !== null){
              if(authentication.loginUser.data.eid !== undefined){
                let email = authentication.loginUser.data|| {}

                getUserByEmail(email)
              }
              else{
                history.push('/login')
              }
            }
            else{
              history.push('/login')
            }
          }
        }
      }
    }
	
    componentDidUpdate(prevProps: AuthenticatedProps, prevState: AuthenticatedState) {
      const { authentication, history, providerData, selectedOrganization, authUser, getCarePlanToSign, getDetailToUpdate, getProviders, setProviderList, setSelectedOrganization, setSelectedProvider, showOrganizationModal } = this.props
	    if(prevProps.authentication.user.loading !== authentication.user.loading){
        if(!authentication.user.error && authentication.user.success){
          if(authentication.user.data.user_id !== undefined){
            authUser(true)
            if(authentication.user.data.provider_data!==undefined){
              if(authentication.user.data.organization_data.length>0){
                if(authentication.user.data.organization_data.length===1) {
                  const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''
                  const email = JSON.parse(localStorage.getItem('p_sid')|| '{}')
                  setSelectedOrganization(authentication.user.data.organization_data[0])
                  getCarePlanToSign(authentication.user.data.organization_data[0].organization_id, email.eid, token)
                  getDetailToUpdate(authentication.user.data.organization_data[0].organization_id, email.eid, token)
                }
                else {
                  showOrganizationModal(true)
                }
              }
            
              if (authentication.user.data.provider_data.length!==0) {
                const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''
                const email = JSON.parse(localStorage.getItem('p_sid')|| '{}')
                setSelectedProvider(authentication.user.data.provider_data[0])
                getCarePlanToSign(authentication.user.data.organization_id, email.eid, token)
                getDetailToUpdate(authentication.user.data.organization_data[0].organization_id, email.eid, token)
              }
            }
          }
          else
            history.push('/login')
        }
      }

      if( prevProps.selectedOrganization.organization_id !== selectedOrganization.organization_id && selectedOrganization.organization_id!==-1 ){
        if (authentication.user.data.provider_data.length === 0) {
          if(localStorage.getItem('token') !== null && localStorage.getItem('token')!=='undefined'){
            const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token')|| '') : ''
            getProviders(selectedOrganization.organization_id, token)
          }
        }
      }

      if(prevProps.providerData.loading!==providerData.loading){
        if(providerData.success&&!providerData.error){
          if(providerData.data.length>0){
            setSelectedProvider(providerData.data[0])
            setProviderList(providerData.data)
          }
        }
      }
    }
  
    render() {
      const { ...props } = this.props
      return  <ComposedComponent {...props} />
    }
  }

  const mapStateToProps = (state: any) => ({
    authentication: state.authentication,
    providerData: state.userAccount.providers,
    selectedOrganization: state.authentication.selectedOrganization
  })

  const mapDispatchToProps = (dispatch: any) => ({
    authUser: (isAuth: boolean) => dispatch(authUser(isAuth)),
    getCarePlanToSign: (organizationId: number, eid: string, token: string) => dispatch(getCarePlanToSign(organizationId, eid, token)),
    getDetailToUpdate: (id: number, eid: string, token: string) => dispatch(getDetailToUpdate(id, eid, token)),
    getProviders: (organization_id: number, token: string) => dispatch(getProviders(organization_id, token)),
    getUserByEmail: (data: {email: string; generateToken: boolean}) => dispatch(getUserByEmail(data)),
    setProviderList: (providerList: Array<Provider>) => dispatch(setProviderList(providerList)),
    setSelectedOrganization: (organization: Organization) => dispatch(setSelectedOrganization(organization)),
    setSelectedProvider: (provider: Provider) => dispatch(setSelectedProvider(provider)),
    setUser: (data: User) => dispatch(setUser(data)),
    showOrganizationModal: (organizationModal: boolean) => dispatch(showOrganizationModal(organizationModal))
  })
	
  return withRouter(connect(mapStateToProps, mapDispatchToProps)(Authenticated))
}

export default isAuthenticated